import { AddressDto, CreateBusinessCustomerRequestDto } from '@/api/generated';
import {
  addressTranslation,
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type CustomersBusinessCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  form: Form & {
    address: Address;
    button: {
      checkNip: string;
    };
    flagOption: FlagOptionsTranslation;
    statusOption: CustomerStatusOptionsTranslation;
  };
  titleAdd: string;
  titleEdit: string;
};
type Address = Record<keyof AddressDto, string>;

type Form = Record<
  keyof Omit<CreateBusinessCustomerRequestDto, 'address' | 'firstContact'>,
  string
>;

export const customersBusinessCreateTranslation: CustomersBusinessCreateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  form: {
    address: addressTranslation,
    button: {
      checkNip: 'Pobierz dane',
    },
    flag: 'Flaga',
    flagOption: flagOptionsTranslation,
    foundingDate: 'Data założenia',
    name: 'Nazwa',
    nip: 'Numer NIP',
    regon: 'Regon',
    status: 'Status',
    statusOption: customerStatusOptionsTranslation,
  },
  titleAdd: 'Dodaj klienta biznesowego',
  titleEdit: 'Edycja klienta biznesowego',
};
